export default __webpack_public_path__ + "img/bc439f301dc46689dc4b9411e115ca98.svg";